import * as m from "~/paraglide/messages";

interface AiGeneratedBadgeProps {
  className?: string;
  id?: string;
}

/**
 * EU AI Act Article 50 transparency badge.
 * Displays a small "AI-generated" label with tooltip explaining
 * Mistral AI assistance. Place near AI-generated output.
 */
export function AiGeneratedBadge({ className, id }: AiGeneratedBadgeProps) {
  return (
    <span
      id={id}
      className={`inline-flex items-center gap-1 text-xs ${className ?? ""}`}
      style={{ color: "var(--text-muted)" }}
      title={m.ai_generated_badge_text()}
      role="note"
      aria-label={m.ai_generated_badge_text()}
      data-compliance="eu-ai-act-art-50"
      data-ai-provider="mistral"
      data-ai-disclosure="generated-output"
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        className="flex-shrink-0"
      >
        <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" />
        <path d="M20 3v4" />
        <path d="M22 5h-4" />
      </svg>
      {m.ai_generated_badge_label()}
    </span>
  );
}
